import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import ModelContentSelector from './ModelContentSelector';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { confirmButtons } from 'components/Modals/ModalButtons';
import { useTranslation } from 'localization/useTranslation';
import Icons from 'components/Common/Icons';
import { ContentType } from 'utils/dtdl';
/**
 * @typedef {object} ModelContentSelectorModalProps
 * @property {boolean} isOpen
 * @property {Function} onConfirm
 * @property {Function} onCancel
 * @property {Array} selectedItems
 * @property {ContentType} contentType
 * @property {boolean} [isSingleSelect]
 */

/**
 *
 * @param {ModelContentSelectorModalProps} props
 * @returns {JSX.Element}
 */
const ModelContentSelectorModal = ({
  isOpen, onConfirm, onCancel, selectedItems,
  contentType = ContentType.TELEMETRY,
  isSingleSelect }) => {
  const T = useTranslation();

  const selectedSignals = useRef([]);

  const onSelectionChanged = useCallback(newSelectedSignals => {
    selectedSignals.current = newSelectedSignals;
  }, []);

  const _onConfirm = useCallback(() => {
    onConfirm(selectedSignals.current);
  }, [onConfirm]);

  return (
    <Modal
      variant={ModalVariant.large}
      title={contentType === ContentType.TELEMETRY ? T.modals.selectsignals.title : T.modals.selectproperties.title}
      titleIconVariant={contentType.TELEMETRY ? Icons.Signals : Icons.Properties}
      isOpen={isOpen}
      onClose={onCancel}
      actions={confirmButtons({ T, onConfirm: _onConfirm, onCancel: onCancel })}
    >
      <ModelContentSelector
        onSelectionChanged={onSelectionChanged}
        initialSelectedContents={selectedItems}
        contentType={contentType}
        isSingleSelect={isSingleSelect}
      />
    </Modal>
  );
};

ModelContentSelectorModal.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  selectedItems: PropTypes.array,
  contentType: PropTypes.oneOf(Object.values(ContentType))
};

export default React.memo(ModelContentSelectorModal);
